var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-lg-12 mb-8"},[_c('student-profile-tab-finance-invoice-history-table',{attrs:{"value":_vm.value}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }